module.exports = __webpack_public_path__ + "img/cefr.6b956897.png";